import { render, staticRenderFns } from "./StmtTypeHelplist.vue?vue&type=template&id=13f46f1b&"
import script from "./StmtTypeHelplist.vue?vue&type=script&lang=js&"
export * from "./StmtTypeHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports